import { Link } from "react-router-dom";
import { ShoppingBagIcon, UserGroupIcon } from "@heroicons/react/24/outline";

// Unified CTA (Merged: OrderCTA + CTA)
export const UnifiedCTA = () => (
  <section className="py-16 bg-gradient-to-br from-green-600 to-emerald-700">
    <div className="container mx-auto px-4">
      <div className="max-w-5xl mx-auto">
        {/* Main Heading */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-green-100">
            Join 850+ businesses already growing with AgriFlow
          </p>
        </div>

        {/* Two-Column CTA */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Order Now Section */}
          <div className="bg-white rounded-2xl p-8 shadow-2xl">
            <div className="flex items-center mb-4">
              <ShoppingBagIcon className="w-8 h-8 text-green-600 mr-3" />
              <h3 className="text-2xl font-bold text-gray-900">Place an Order</h3>
            </div>
            <p className="text-gray-600 mb-6">
              Need products now? Contact us instantly and get your order delivered fast.
            </p>
            <div className="space-y-3">
              <a
                href="https://wa.me/2348012345678"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-green-600 text-white px-6 py-3 rounded-lg font-semibold text-center shadow hover:bg-green-700 transition"
              >
                ��� Order via WhatsApp
              </a>
              <a
                href="tel:+2348012345678"
                className="block w-full bg-green-100 text-green-700 px-6 py-3 rounded-lg font-semibold text-center shadow hover:bg-green-200 transition"
              >
                ��� Call: +234 801 234 5678
              </a>
              <Link
                to="/contact"
                className="block w-full bg-white border-2 border-green-600 text-green-700 px-6 py-3 rounded-lg font-semibold text-center shadow hover:bg-green-50 transition"
              >
                ✉️ Contact Form
              </Link>
            </div>
          </div>

          {/* Partner Signup Section */}
          <div className="bg-white rounded-2xl p-8 shadow-2xl">
            <div className="flex items-center mb-4">
              <UserGroupIcon className="w-8 h-8 text-green-600 mr-3" />
              <h3 className="text-2xl font-bold text-gray-900">Become a Partner</h3>
            </div>
            <p className="text-gray-600 mb-6">
              Restaurant owner, retailer, or supplier? Join AgriFlow Food Hub and grow your business.
            </p>
            <div className="space-y-4 mb-6">
              <div className="flex items-start">
                <span className="text-green-600 mr-2">✓</span>
                <span className="text-gray-700">Access to 5,000+ products</span>
              </div>
              <div className="flex items-start">
                <span className="text-green-600 mr-2">✓</span>
                <span className="text-gray-700">Wholesale pricing & credit terms</span>
              </div>
              <div className="flex items-start">
                <span className="text-green-600 mr-2">✓</span>
                <span className="text-gray-700">Reliable delivery & support</span>
              </div>
            </div>
            <Link
              to="/register"
              className="block w-full bg-green-600 text-white px-6 py-4 rounded-lg font-bold text-center text-lg shadow-lg hover:bg-green-700 transition"
            >
              Sign Up Now – It's Free
            </Link>
          </div>
        </div>

        {/* Trust Badge */}
        <div className="text-center mt-8 text-green-100 text-sm">
          ��� 100% Secure • No Hidden Fees • Money-Back Guarantee
        </div>
      </div>
    </div>
  </section>
);
